/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactSummary } from './ContactSummary.js';
import {
    ContactSummaryFromJSON,
    ContactSummaryFromJSONTyped,
    ContactSummaryToJSON,
} from './ContactSummary.js';

/**
 * 
 * @export
 * @interface CreateLiveAssistDemoData
 */
export interface CreateLiveAssistDemoData {
    /**
     * 
     * @type {ContactSummary}
     * @memberof CreateLiveAssistDemoData
     */
    contact?: ContactSummary;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveAssistDemoData
     */
    wsUrl?: string;
}

/**
 * Check if a given object implements the CreateLiveAssistDemoData interface.
 */
export function instanceOfCreateLiveAssistDemoData(value: object): boolean {
    return true;
}

export function CreateLiveAssistDemoDataFromJSON(json: any): CreateLiveAssistDemoData {
    return CreateLiveAssistDemoDataFromJSONTyped(json, false);
}

export function CreateLiveAssistDemoDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLiveAssistDemoData {
    if (json == null) {
        return json;
    }
    return {
        
        'contact': json['contact'] == null ? undefined : ContactSummaryFromJSON(json['contact']),
        'wsUrl': json['wsUrl'] == null ? undefined : json['wsUrl'],
    };
}

export function CreateLiveAssistDemoDataToJSON(value?: CreateLiveAssistDemoData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contact': ContactSummaryToJSON(value['contact']),
        'wsUrl': value['wsUrl'],
    };
}

